<app-loading *ngIf="viewModel.isLoading$ | async" [options]="viewModel.loadingOpts$ | async"> </app-loading>
<lib-sticky-modal>
  <lib-sticky-header [stickyCollectionKey]="stickyCollectionKey" [stickyOrder]="0">
    <div class="bs-section-title mt-16px">Change Password</div>
    <div class="change-password-subheader">{{ viewModel.userFullName$ | push }}</div>
    <hr class="mt-28px mb-none" />
  </lib-sticky-header>
  <lib-sticky-body>
    <lib-reactive-form-group
      #form
      [bindTo]="viewModel.req"
      (unsavedChanges$)="viewModel.connectToUnsavedChanges($event)"
      (formSubmitted$)="viewModel.formSubmitted(viewModel?.req)">
      <lib-reactive-form-password
        class="block pt-24px"
        [inputName]="'oldPassword'"
        [required]="true"
        [showHidePassword]="true"
        [label]="'Old Password'"
        [placeholder]="'Old Password'"
        [bindingProperty]="'oldPassword'">
      </lib-reactive-form-password>
      <lib-reactive-form-password
        [inputName]="'password'"
        [required]="true"
        [creatingOrUpdatingPassword]="true"
        [confirmPassword]="true"
        [showHidePassword]="true"
        [label]="'New Password'"
        [placeholder]="'New Password'"
        [bindingProperty]="'newPassword'">
      </lib-reactive-form-password>
      <lib-reactive-form-password
        [inputName]="'confirmPassword'"
        [required]="true"
        [creatingOrUpdatingPassword]="true"
        [showHidePassword]="true"
        [confirmPassword]="true"
        [label]="'Confirm New Password'"
        [placeholder]="'Retype your new password.'">
      </lib-reactive-form-password>
    </lib-reactive-form-group>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-neutral (buttonClicked)="cancel()">Cancel</lib-button-neutral>
      <lib-button-primary [disabled]="form.disableSubmit$ | async" (buttonClicked)="form.submitForm()">
        Change Password
      </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
